import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Building2,
  Mail,
  CreditCard,
  LogOut,
  Menu,
  X,
  ChevronRight,
  Shield,
  Users,
} from 'lucide-react';

const NAV_ITEMS = [
  { path: '/superadmin/tenants',                       label: 'Tenant Management',     icon: Building2 },
  { path: '/superadmin/lead-ambassadors',              label: 'Lead Ambassadors',      icon: Users },
  { path: '/bulkemailing',                             label: 'Bulk Emailing',         icon: Mail },
  { path: '/superpayments',                            label: 'Payments',              icon: CreditCard },
];

const SuperAdminLayout = () => {
  const location  = useLocation();
  const navigate  = useNavigate();
  const [open, setOpen] = useState(true);

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      {/* ── Sidebar ── */}
      <aside
        className={`
          ${open ? 'w-64' : 'w-16'}
          flex flex-col bg-white border-r border-gray-200 shadow-sm
          transition-all duration-200 flex-shrink-0
        `}
      >
        {/* Logo row */}
        <div className="flex items-center gap-3 px-4 py-5 border-b border-gray-100">
          <div className="w-8 h-8 bg-[#843FEF] rounded-lg flex items-center justify-center flex-shrink-0">
            <Shield size={16} className="text-white" />
          </div>
          {open && (
            <div className="min-w-0">
              <p className="text-sm font-bold text-gray-800 truncate">The Skill Genie</p>
              <p className="text-xs text-gray-400">Super Admin</p>
            </div>
          )}
          <button
            onClick={() => setOpen(!open)}
            className="ml-auto text-gray-400 hover:text-gray-600 flex-shrink-0"
            aria-label="Toggle sidebar"
          >
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 py-4 px-2 space-y-0.5 overflow-y-auto">
          {NAV_ITEMS.map((item) => {
            const { path, label, icon: Icon } = item;
            return (
              <Link
                key={path}
                to={path}
                title={!open ? label : undefined}
                className={`
                  flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors
                  ${isActive(path)
                    ? 'bg-purple-50 text-[#843FEF]'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}
                `}
              >
                <Icon size={18} className="flex-shrink-0" />
                {open && (
                  <>
                    <span className="flex-1 truncate">{label}</span>
                    {isActive(path) && <ChevronRight size={14} className="flex-shrink-0" />}
                  </>
                )}
              </Link>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="p-3 border-t border-gray-100">
          <button
            onClick={handleLogout}
            title={!open ? 'Logout' : undefined}
            className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-red-500 hover:bg-red-50 transition-colors"
          >
            <LogOut size={18} className="flex-shrink-0" />
            {open && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* ── Page content ── */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default SuperAdminLayout;